import {ProDrawer, ProDrawerProps} from '../../../../../Components/ProDrawer';
import ProForm from '../../../../../Components/ProForm';
import {Input, message} from 'antd';
import {ActionData, addAction} from '../../service';
import {errorMessage} from '../../../../../Utils/common';

interface ActionEditDrawerProps extends ProDrawerProps {
    parentId: string;
    initData?: ActionData;
}

export function ActionEditDrawer({
    onOk,
    parentId,
    initData,
    ...props
}: ActionEditDrawerProps) {
    const isEdit = !!initData;

    async function onFinish(data: ActionData) {
        try {
            await addAction(parentId, data);
            message.success('保存成功!');
            onOk?.();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    return (
        <ProDrawer.Form
            {...props}
            initialValues={initData}
            title={`${isEdit ? '修改' : '新增'}操作项`}
            width={600}
            onFinish={onFinish}>
            <ProForm.Field name="id" hidden>
                <Input placeholder="请输入子名称" />
            </ProForm.Field>

            <ProForm.Field
                label="名称"
                name="name"
                rules={[{required: true}]}
                disabled={isEdit}>
                <Input placeholder="请输入子名称" />
            </ProForm.Field>

            <ProForm.Field
                label="编码"
                name="code"
                rules={[{required: true}]}
                disabled={isEdit}>
                <Input placeholder="请输入编码" />
            </ProForm.Field>

            <ProForm.Field label="请求地址" name="url">
                <Input placeholder={`请输入以"/"开头的有效的请求地址`} />
            </ProForm.Field>
        </ProDrawer.Form>
    );
}
